import gql from 'graphql-tag';

export const updateCostOffsetCodeMutation = gql(/* GraphQL */ `
  mutation updateCostOffsetCode(
    $updateCostOffsetCodeRequest: UpdateCostOffsetCodeRequest!
  ) {
    updateCostOffsetCode(
      updateCostOffsetCodeRequest: $updateCostOffsetCodeRequest
    ) {
      costOffsetCode {
        id
        code
        description
        groupId
        groupType
      }
    }
  }
`);
